<template>
  <section>
    <header v-if="title">{{ title }}</header>
    <main class="dialog-content" v-html="text"></main>
  </section>
</template>
<script>
export default {
  props: {
    title: String,
    text: String,
    time: { type: Number, default: 3000 }
  },
  methods: {},
  created() {
    setTimeout(() => {
      this.$emit('close')
    }, this.time)
  }
}
</script>

<style lang="scss" scoped>
header {
  font-size: 1rem;
  text-transform: uppercase;
  font-weight: bold;
  padding: 25px 25px 0;
}
</style>
